export enum QuerySuggestionResource {
    Activities = 'activities',
    ActivityEvents = 'activityevents',
    Archives = 'archives',
    Credits = 'credits',
    DnsRecords = 'dnsrecords',
    Domains = 'domains',
    Invoices = 'invoices',
    PaymentMethods = 'paymentmethods',
    Policies = 'policies',
    Projects = 'projects',
    Restorations = 'restorations',
    TeamAggregations = 'teamaggregations',
    Teams = 'teams',
    Databases = 'databases',
    Tables = 'tables',
    Rows = 'rows',
    Schedules = 'schedules',
    Platforms = 'platforms',
    Keys = 'keys',
    Webhooks = 'webhooks',
    Notifications = 'notifications',
    Certificates = 'certificates',
    Realtime = 'realtime',
    Rules = 'rules',
    Installations = 'installations',
    Repositories = 'repositories',
    VcsComments = 'vcscomments',
    VcsCommentLocks = 'vcscommentlocks',
    Reports = 'reports',
    Insights = 'insights',
    Users = 'users',
    Cache = 'cache',
    Tokens = 'tokens',
    Authenticators = 'authenticators',
    Challenges = 'challenges',
    Sessions = 'sessions',
    Identities = 'identities',
    Memberships = 'memberships',
    Buckets = 'buckets',
    Providers = 'providers',
    Messages = 'messages',
    PushLedger = 'pushledger',
    Topics = 'topics',
    Subscribers = 'subscribers',
    Targets = 'targets',
    PresenceLogs = 'presencelogs',
    Companies = 'companies',
    BillingAddresses = 'billingaddresses',
    BillingAggregations = 'billingaggregations',
    BillingAggregationResources = 'billingaggregationresources',
    BillingTeamProjectAggregations = 'billingteamprojectaggregations',
    BillingTeamAggregationsV2 = 'billingteamaggregations_v2',
    BillingTeamAggregationResources = 'billingteamaggregationresources',
    BillingInvoicesV2 = 'billinginvoices_v2',
    BillingAddons = 'billingaddons',
    Alerts = 'alerts',
    Payments = 'payments',
    BillingDiscounts = 'billingdiscounts',
    ResourcesDeleted = 'resourcesdeleted',
    Sources = 'sources',
    Deals = 'deals',
    Blocks = 'blocks',
    Threats = 'threats',
    Feedbacks = 'feedbacks',
    Disputes = 'disputes',
    WafRules = 'wafrules',
    ShInstallations = 'sh_installations',
    MigrationDatabases = 'migrationdatabases',
    MigrationProjects = 'migrationprojects',
    AffiliateLinks = 'affiliatelinks',
    AffiliateReferrals = 'affiliatereferrals',
    AffiliateRewards = 'affiliaterewards',
    Apps = 'apps',
    AppSecrets = 'appsecrets',
    AppInstallations = 'appinstallations',
    AppKeys = 'appkeys',
    Oauth2Grants = 'oauth2grants',
    Oauth2Consents = 'oauth2consents',
    Oauth2Tokens = 'oauth2tokens',
    Attributes = 'attributes',
    Indexes = 'indexes',
    Functions = 'functions',
    Sites = 'sites',
    Deployments = 'deployments',
    Variables = 'variables',
    Migrations = 'migrations',
    ResourceTokens = 'resourcetokens',
    Transactions = 'transactions',
    TransactionLogs = 'transactionlogs',
    AnalyticsProperties = 'analyticsproperties',
    DedicatedDatabases = 'dedicateddatabases',
    DedicatedDatabaseConfigs = 'dedicateddatabaseconfigs',
    DedicatedDatabaseRuntimes = 'dedicateddatabaseruntimes',
    DedicatedDatabaseOperations = 'dedicateddatabaseoperations',
    DedicatedDatabaseBackups = 'dedicateddatabasebackups',
    DedicatedDatabaseRestorations = 'dedicateddatabaserestorations',
    DedicatedDatabaseBranches = 'dedicateddatabasebranches',
}
